export enum ModuloAnaliseEnum {
    CINEMA_HOME_VIDEO = 1,
    JOGO_ELETRONICO_RPG = 2,
    SEAC_VOD = 3,
    TV_ABERTA = 4,
    RADIO = 5,
}
